import * as React from "react";
import PropTypes from "prop-types";
import BasicSelect from "../Components/CustomSelect/SelectForm";
import axios from "axios";
import { genURL } from "../_getjson";

export default function SelectData(props) {
  const { origin, title, defaultselect, opentitle } = props;

  const [state, setState] = React.useState({
    loading: false,
    menuItemLists: [],
    error: null,
  });

  React.useEffect(() => {
    console.log("SelectData useEffect - origin:", origin);
    if (origin) {
      loadData();
    }
    // eslint-disable-next-line
  }, [origin]);

  const getStaticData = (origin) => {
    const staticDataMap = {
      PriceType: [
        { id: "0", value: "ราคาไม่รวมภาษี" },
        { id: "1", value: "ราคารวมภาษี" },
        { id: "2", value: "ภาษีอัตราศูนย์" },
      ],
      CALCWTAX: [
        { id: "0", value: "ตั้งหนี้อื่นๆ" },
        { id: "1", value: "ค่าบริการบริการ" },
      ],
      ProductType: [
        { id: "0", value: "สินค้าซื้อมาขายไป" },
        { id: "1", value: "สินค้าบริการ" },
        { id: "2", value: "ไม่มีสต็อก (ทรัพย์สิน)" },
      ],
      BuyType: [
        { id: "0", value: "ซื้อสินค้า" },
        { id: "1", value: "บริการมีภาษี หัก ณ ที่จ่าย" },
      ],
      SaleType: [
        { id: "0", value: "ขายสินค้า" },
        { id: "1", value: "บริการมีภาษี หัก ณ ที่จ่าย" },
      ],
      STOCKPROC: [
        { id: "0", value: "ขอรับคืนสินค้าและลดหนี้" },
        { id: "1", value: "ลดหนี้เนื่องจากราคาผิด" },
      ],
      STOCKPROC1: [
        { id: "0", value: "รับคืนสินค้าและลดหนี้" },
        { id: "1", value: "ลดหนี้เนื่องจากราคาผิด" },
      ],
      PriceReturnType: [
        { id: "0", value: "คืนเงินสด" },
        { id: "1", value: "เอาไว้หักชำระหนี้" },
      ],
      Persontype: [
        { id: "0", value: "นิติบุคคล" },
        { id: "1", value: "บุคคลธรรมดา" },
      ],
      Creditshare: [
        { id: "0", value: "ใช้วงเงินส่วนตัว" },
        { id: "1", value: "ใช้วงเงินรวม" },
      ],
      Creditflag: [
        { id: "0", value: "ปิดบัญชี" },
        { id: "1", value: "เปิดบัญชี" },
        { id: "2", value: "หยุดชั่วคราว" },
      ],
      Fee: [
        { id: "0", value: "บริษัทออกให้" },
        { id: "1", value: "ลูกค้าจ่ายเองให้หักในบัตร" },
        { id: "2", value: "ลูกค้าจ่ายเงินสด" },
      ],
      Sex: [
        { id: "ชาย", value: "ชาย" },
        { id: "หญิง", value: "หญิง" },
        { id: "-", value: "-" },
      ],
      Pricelevel: [
        { id: "0", value: "ระดับที่ 1" },
        { id: "1", value: "ระดับที่ 2" },
        { id: "2", value: "ระดับที่ 3" },
        { id: "3", value: "ระดับที่ 4" },
        { id: "4", value: "ระดับที่ 5" },
        { id: "5", value: "ระดับที่ 6" },
        { id: "6", value: "ระดับที่ 7" },
        { id: "7", value: "ระดับที่ 8" },
        { id: "8", value: "ระดับที่ 9" },
        { id: "9", value: "ระดับที่ 10" },
      ],
    };

    return staticDataMap[origin] || [];
  };

  const loadData = async () => {
    setState((prevState) => ({ ...prevState, loading: true, error: null }));

    try {
      let listItem = [];

      // Check if it's static data first
      const staticData = getStaticData(origin);
      if (staticData.length > 0) {
        listItem = staticData;
      }
      // Check if it's API data
      else if (
        [
          "_prefix",
          "BOOKNO",
          "BOOKNO1",
          "Csbank",
          "Bankbranch",
          "checkkm",
          "Occupation",
          "Maingroup",
          "Subgroup1",
          "Creditcode",
          "Credittype",
          "cscncode",
          "PROJECT",
        ].includes(origin)
      ) {
        listItem = await fetchApiData(origin);
      }

      setState((prevState) => ({
        ...prevState,
        menuItemLists: listItem,
        loading: false,
        error: null,
      }));

      console.log("SelectData loaded successfully:", {
        origin,
        itemCount: listItem.length,
      });
    } catch (error) {
      // พยายามดึง url จาก fetchApiData หรือจาก error config
      let apiUrl = "";
      if (typeof error.config === "object" && error.config.url) {
        apiUrl = error.config.url;
      } else if (typeof origin !== "undefined") {
        // ลองดึงจาก apiConfigMap
        const apiConfigMap = {
          BOOKNO: "CSBANKCASHIN/GetBookno?top=500",
          BOOKNO1: "CSBANKCASHIN/GetBookno?top=500",
          Credittype: "CSBANKCASHIN/Credittype?",
          _prefix: "PSPREFIX/ALL?MFLAG=1",
          checkkm: "PSCHEACKKM/GetAll?",
        };
        apiUrl = apiConfigMap[origin] || "";
      }
      console.error("SelectData error:", error, "URL:", apiUrl);
      setState((prevState) => ({
        ...prevState,
        menuItemLists: [],
        loading: false,
        error:
          (apiUrl ? `URL: ${apiUrl} | ` : "") +
          (error.message || "เกิดข้อผิดพลาดในการโหลดข้อมูล"),
      }));
    }
  };

  const fetchApiData = async (origin) => {
    const apiConfigMap = {
      BOOKNO: "CSBANKCASHIN/GetBookno?top=500",
      BOOKNO1: "CSBANKCASHIN/GetBookno?top=500",
      Credittype: "CSBANKCASHIN/Credittype?",
      _prefix: "PSPREFIX/ALL?MFLAG=1",
      checkkm: "CHECKKM/GetAll?",
      Occupation: "PSOCCUPATION/getall?top=300",
      Maingroup: "CSARMAINGROUP/GetAll?MFLAG=1",
      Subgroup1: "CSARSUBGROUP1/GetAll?MFLAG=1",
      Creditcode: "CSCREDITCODE/GetCreditcode?MFLAG=1",
      Csbank: "CSBANKCASHIN/Csbank?ALL",
      Bankbranch: "CSBANKCASHIN/Bankbranch?",
      cscncode: "CSCNCODE/GETALL?",
      PROJECT: "CSPROJECT/Getprojectall?",
    };

    const url = apiConfigMap[origin];
    if (!url) {
      throw new Error(`ไม่พบ API configuration สำหรับ ${origin}`);
    }

    console.log("Fetching API data:", genURL(url));
    const response = await axios.get(genURL(url), { timeout: 360000 });

    if (!response.data || !Array.isArray(response.data)) {
      throw new Error("ข้อมูลที่ได้รับจาก API ไม่ถูกต้อง");
    }

    return processApiResponse(origin, response.data);
  };

  const processApiResponse = (origin, data) => {
    if (data.length === 0) {
      return [];
    }

    let listItem = [];

    switch (origin) {
      case "BOOKNO":
      case "BOOKNO1":
        listItem.push({ id: "0", value: "กรุณาเลือกเลขบัญชี(ถ้ามี)" });
        data.forEach((item) => {
          listItem.push({
            id: item.BOOKNO,
            value: `${item.BOOKNO}-${item.BANKNAME}`,
          });
        });
        break;

      case "Occupation":
        listItem.push({ id: "0", value: "กรุณาเลือกอาชีพ" });
        data.forEach((item) => {
          listItem.push({
            id: item.CODE,
            value: item.MYNAMETH,
          });
        });
        break;

      case "cscncode":
        listItem.push({ id: "", value: "ไม่มีสาเหตุ" });
        data.forEach((item) => {
          listItem.push({
            id: item.CODE,
            value: item.MYNAMETH,
          });
        });
        break;

      case "PROJECT":
        listItem.push({ id: "", value: "ไม่มีโครงการ" });
        data.forEach((item) => {
          listItem.push({
            id: item.code,
            value: item.MYNAMETH,
          });
        });
        break;

      case "Bankbranch":
        data.forEach((item) => {
          listItem.push({
            id: item.bankbranch,
            value: item.bankbranch,
          });
        });
        break;

      case "Credittype":
        data.forEach((item) => {
          listItem.push({
            id: item.CODE,
            value: `${item.CODE}-${item.MYNAMETH}`,
          });
        });
        break;

      default:
        // For other API types that have CODE and MYNAMETH
        data.forEach((item) => {
          listItem.push({
            id: item.CODE,
            value: item.MYNAMETH,
          });
        });
        break;
    }

    return listItem;
  };

  if (state.loading) {
    return <div style={{ padding: "8px" }}>กำลังโหลดข้อมูล...</div>;
  }

  if (state.error) {
    console.error("SelectData error:", state.error);
    return <></>;
  }

  if (state.menuItemLists.length === 0) {
    return <div style={{ padding: "8px" }}>ไม่พบข้อมูล</div>;
  }

  return (
    <BasicSelect
      opentitle={opentitle}
      MenuItemlist={state.menuItemLists}
      origin={origin}
      valueSelect={(code, name) => {
        props.valueSelect(code, name);
      }}
      title={title}
      defaultselect={defaultselect}
      popup={props.popup}
    />
  );
}

SelectData.propTypes = {
  origin: PropTypes.string.isRequired,
  title: PropTypes.string,
  defaultselect: PropTypes.string,
  opentitle: PropTypes.bool,
  valueSelect: PropTypes.func.isRequired,
  popup: PropTypes.bool,
};

SelectData.defaultProps = {
  title: "",
  defaultselect: "",
  opentitle: false,
  popup: false,
};
